export default "__VITE_ASSET__mOHXKjj2__"